import {
  SET_SEARCH_QUERY,
  POPULATE_BUS_LIST,
  FILTER_BUS_LIST,
  RESET_FILTER,
  TICKET_DETAILS,
  PASSENGER_DETAILS,
  RESET_STORE,
  SET_HOME_ACTIVE_MENU,
  SET_TRIPS_ACTIVE_MENU,
  SET_SEATAPI_DATA,
} from './action-types';

export const setSearchQuery = (query) => ({
  type: SET_SEARCH_QUERY,
  payload: query,
});

export const populateBusList = (response) => ({
  type: POPULATE_BUS_LIST,
  payload: response,
});

export const filterBusList = (response) => ({
  type: FILTER_BUS_LIST,
  payload: response,
});

export const ticketDetails = (response) => ({
  type: TICKET_DETAILS,
  payload: response,
});

export const passengerDetails = (response) => ({
  type: PASSENGER_DETAILS,
  payload: response,
});

export const resetFilter = (response) => ({
  type: RESET_FILTER,
  payload: response,
});

export const resetStore = (config) => ({type: RESET_STORE, payload: config});

export const setHomeActiveMenu = (menu) => ({
  type: SET_HOME_ACTIVE_MENU,
  payload: menu,
});

export const setTripsActiveMenu = (menu) => ({
  type: SET_TRIPS_ACTIVE_MENU,
  payload: menu,
});

export const setSeatAPIData = (response) => ({
  type: SET_SEATAPI_DATA,
  payload: response,
});
